import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard/Dashboard";
import "bootstrap/dist/css/bootstrap.min.css";
import Insurancescreen from "./pages/Insurancescreen/Insurancescreen";
import SubscribedPackageDetails from "./pages/SubscribedPackageDetails/SubscribedPackageDetails";
import AllSubscriptions from "./pages/SubscribedPackageDetails/AllSubscriptions";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import { LoadingProvider } from "./contexts/LoadingContext";
import Loader from "./components/loader";
import "bootstrap/dist/css/bootstrap.min.css";

const App = () => {
  return (
    <LoadingProvider>
      <Loader />
      <Router>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route
            path="/insurancescreen/:type/:apiService"
            element={<Insurancescreen />}
          />
          <Route
            path="/subscribed-package-details/:apiService"
            element={<SubscribedPackageDetails />}
          />
          <Route
            path="/all"
            element={<AllSubscriptions />}
          />
          <Route path="/error" element={<ErrorPage />} />
        </Routes>
      </Router>
    </LoadingProvider>
  );
};

export default App;
